import React from "react";
import "../../App.css";
import geek from "../../geek.jpg";
import Footer from "../Footer";

export default function Otaku() {
  return (
    <>
      <h1>Soon</h1>
      <img src={geek} alt="ota" className="SOON" />
      <Footer />
    </>
  );
}
